import { Component } from '@angular/core';

@Component({
  selector: 'app-create-contract',
  templateUrl: './create-contract.component.html',
  styleUrl: './create-contract.component.scss'
})
export class CreateContractComponent {

  bodySpinner:boolean=false;
  selectedDate:any;
  terminateDate:any;
  constructor(){}

  getDateSearchData(event:any){

  }
}
